// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import { createVerticalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { requisitionsProductListLineStyles } from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import Wishlist from "@eisinc/XDL/Icons/Wishlist";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

requisitionsProductListLineStyles.productInfoGridItem = {
    ...cartLineSharedStyles.productInfoGridItem,
    css: css`
       ${cartLineSharedStyles.productInfoGridItem?.css}
            grid-template-columns: 1fr 1fr;
        `,

};
requisitionsProductListLineStyles.productPartNumbersGridItem = {
    css: css`
        grid-column: 1/2;
        display: flex;
        flex-direction: column;
        row-gap: 2px;
        ${xScreen("lte", "sm")} {
            grid-column: 1/3;
        }
    `,
};

requisitionsProductListLineStyles.selectedCheckbox = {
    css: css``,
};


requisitionsProductListLineStyles.viewRequisitionLink = {
    ...createLinkIconStyles({
        icon: Wishlist,
    }),
};

requisitionsProductListLineStyles.badgesWrapper = {
    ...cartLineSharedStyles.badgesWrapper,
};

requisitionsProductListLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

requisitionsProductListLineStyles.certBadgesWrapper = {
    ...cartLineSharedStyles.certBadgesWrapper,
};
requisitionsProductListLineStyles.mfrBadge = {
    ...cartLineSharedStyles.mfrBadge,
};
requisitionsProductListLineStyles.eisBadge = {
    ...cartLineSharedStyles.eisBadge,
};

requisitionsProductListLineStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.productBrand = {
    ...cartLineSharedStyles.brandStyles,
};
requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.smallHeadingText = {
    ...createVerticalSmallHeadingAndTextStyles(
        {
            heading: {
                weight: fontConfig.weight.regular,
                ...fontConfig.singleLinexSmall,
                css: css`
                    display: none;
                    ${xScreen("lte", "md")} {
                        display: block;
                    }
                `,
            },
            text: {
                weight: fontConfig.weight.medium,

            }
        }
    ),
};
requisitionsProductListLineStyles.productAvailabilityWrapper = {
    ...cartLineSharedStyles.productAvailabilityWrapper,
};
requisitionsProductListLineStyles.productImagesBadgesStyles = {
    triggererWrapper: {
        css: css`
        display: inline;`,
    },
    tooltipWrapper: {
        css: css`
           display: inline;
            margin-right: 5px;
        `,
    }
};
